import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=515b2114&scoped=true"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=515b2114&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b2114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515b2114')) {
      api.createRecord('515b2114', component.options)
    } else {
      api.reload('515b2114', component.options)
    }
    module.hot.accept("./DetailList.vue?vue&type=template&id=515b2114&scoped=true", function () {
      api.rerender('515b2114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/DeductionConfirmationForm/component/DetailList.vue"
export default component.exports